module.exports = fox._r("images/bg/btn_blue.png", __webpack_public_path__ + "images/bg/btn_blue.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/bg/btn_blue.png
// module id = 1008
// module chunks = 4